module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAAA+UlEQVRIia3W3RGDIAwA4IxR9M3unBwPXmfwGKA6RtnCYwD6YK8tyE+S1ifMwYcSiAJOuGIgZw0oLmtowZ3uOAHdMWLESJ5GKTMP+DhG4wq4v5pi6ouJGICW900kPw8qJpKD2yUJMKmM8dYUgn2qOkJGWZP2TlaWTzUZPtVleBSL6VNspk2JmDolZsqUiilRSuZMqZmDIv8HpkQpmfPrSYpMg1FS9cUWUe30s6mcoVFe+opMKdqlyoyYandO91WD6s/JoniPnlPKit2lZDmpUpoPZIGyhpmLJmUNkNOdpIxygEF7thMqAG36avOhaAN7pe2nXz+HAVecnnz2CLoQNY8EAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/c2.png
// module id = oi3M
// module chunks = 16